export const prependZero = (number: string): string => {
  if (number.length === 0) return "00";
  if (number.length === 1) return `0${number}`;
  if (number.length > 2)
    throw new Error("Input number must be no more than two characters");
  return number;
};
